// extracted by mini-css-extract-plugin
export default {"add-equipment__links":"add-equipment__links_kEZr5AtT","search-form":"search-form_pUD7iK5a"};